import { InputSelect } from "./InputSelect";
import classNames from "classnames";

interface IProps {
  list: string[];
  id?: string;
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  onClickButton: () => void;
  textButton?: string;
  title?: string;
  className?: string;
  rows: number[];
}

export const ChangeStatusShipping = (props: IProps) => {
  const {
    id,
    value,
    list,
    onChange,
    disabled,
    onClickButton,
    textButton = "Apply",
    title,
    className,
    rows,
  } = props;

  return (
    <div className={classNames("row", className)}>
      <div
        className={`col-md-${rows[0]} d-flex align-items-center justify-content-end`}
      >
        {title}
      </div>
      <div className={`col-md-${rows[1]}`}>
        <InputSelect
          id={id}
          list={list}
          disabled={disabled}
          value={value}
          onChange={onChange}
        />
      </div>
      <div className={`col-md-${rows[2]}`}>
        <button
          type="button"
          className="form-control default-btn apply-btn"
          onClick={onClickButton}
          disabled={disabled}
        >
          {textButton}
        </button>
      </div>
    </div>
  );
};
